// @core/api/endpoints/workflow/list_agent_tools.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAgentToolsResponse,
} from '../../../types/workflow';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/workflow';

/**
 * List agent tools
 * Lists agent tools available in the current scope, builtin seeds included. Supports filtering by kind.
 */
export async function ListAgentTools(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListAgentToolsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/agent-tools`;
  const requestOptions = options;
  return client.get<ListAgentToolsResponse>(requestPath, { ...requestOptions, params });
}
